<template>
  <div class="recharge-activity-page">
    <div class="recharge-activity">会员消费记录</div>
    <div class="flex-row-start">
      <div class="activity-name">手机号</div>
      <el-input
        clearable
        placeholder="请输入手机号"
        v-model="keywords"
        style="width: 250px"
        class="pr30"
        onchange="this.value=this.value.replace(/[^\d]/g,'')"
      ></el-input>
      <el-select v-model="useType" placeholder="请选择" class="pr30">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="search">搜索</el-button>
      <div style="margin: 0 20px">
        <el-date-picker
          v-model="time"
          @change="timeChange"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </div>
      <el-button type="primary" @click="exportTable">导出</el-button>
    </div>
    <div class="flex-row-start">
      <div class="pr30">营销统计</div>
      <div class="pr30 bold">
        充值总金额：
        <span class="colorblue">{{ total_recharge }}</span> 元
      </div>
      <div class="pr30 bold">
        总余额：
        <span class="color-orange">{{ total_member_balance }}</span> 元
      </div>
      <div class="pr30 bold">
        消费总额：
        <span class="colorblue">{{ total_consume }}</span> 元
      </div>
      <div class="pr30 bold">
        会员总数：
        <span class="color-orange">{{ total_member_num }}</span> 人
      </div>
    </div>
    <div class="table-area">
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
        element-loading-text="数据正在加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column align="center" prop="useType" label="类型">
          <template slot-scope="scope">
            {{ scope.row.useType == 1 ? "充值" : scope.row.useType == 2 ? "消费" : "" }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="phoneNum" label="手机号" />
        <el-table-column align="center" prop="createTime" label="时间" />
        <el-table-column align="center" prop="shopName" label="店铺名称" />
        <el-table-column align="center" prop="tranMoney" label="金额（元）">
          <template slot-scope="scope">
            <div class="green-color" v-if="scope.row.useType == 1">
              +{{ scope.row.tranMoney.toFixed(2) }}
            </div>
            <div class="red-color" v-if="scope.row.useType == 2">
              -{{ scope.row.tranMoney.toFixed(2) }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        v-if="tableData.length > 0"
        class="block"
        style="float: right; margin-top: 10px"
      >
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNo"
          :page-size="queryInfo.row"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { rechargeConsumList, excelRrechargeConsumList } from "@/api/index";
import request from "@/utils/request";
export default {
  data() {
    return {
      keywords: "",
      value: "",
      options: [
        { value: "", label: "全部" },
        { value: "1", label: "充值" },
        { value: "2", label: "消费" },
      ],
      tableData: [],
      queryInfo: {
        pageNo: 1,
        row: 10,
      },
      total: 0,
      loading: false,
      total_consume: 0,
      total_member_num: 0,
      total_recharge: 0,
      total_member_balance: 0,
      time: "",
      startTime: "",
      endTime: "",
      useType: "",
    };
  },
  watch: {
    useType(val) {
      this.queryInfo.pageNo = 1;
      this.getRechargeConsumList();
    },
  },
  created() {
    this.getRechargeConsumList();
  },
  methods: {
    getRechargeConsumList() {
      this.loading = true;
      rechargeConsumList({
        pageNumber: this.queryInfo.pageNo,
        pageSize: this.queryInfo.row,
        phoneNum: this.keywords,
        useType: this.useType,
        version: "2.0",
        startTime: this.startTime,
        endTime: this.endTime,
      }).then((res) => {
        this.loading = false;
        if (res.code == 1) {
          this.tableData = res.data.pager.list;
          this.total = res.data.pager.totalCount;
          this.total_recharge = res.data.shopMemberDataDto.total_recharge;
          this.total_member_balance = res.data.shopMemberDataDto.total_member_balance;
          this.total_consume = res.data.shopMemberDataDto.total_consume;
          this.total_member_num = res.data.shopMemberNum.total_member_num;
        } else if (res.code == -1) {
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      this.getRechargeConsumList();
    },
    search() {
      this.queryInfo.pageNo = 1;
      this.getRechargeConsumList();
    },
    exportTable() {
      if (!this.tableData.length) {
        return this.$notify.warning("没有数据可以导出");
      }
      location.href = `${request.baseUrl}/edcmanageapi/Member_excelRrechargeConsumList?userId=${localStorage.userId}&sessionId=${localStorage.sessionId}&useType=${this.value}&phoneNum=${this.keywords}&startTime=${this.startTime}&endTime=${this.endTime}`;
      this.getRechargeConsumList();
    },
    timeChange(val) {
      if (val) {
        this.startTime = val[0];
        this.endTime = val[1];
      } else {
        this.startTime = "";
        this.endTime = "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.pr30 {
  padding-right: 30px;
  box-sizing: border-box;
}
.colorblue {
  color: #3388ff;
}
.red-color {
  color: red;
}
.green-color {
  color: green;
}
.recharge-activity-page {
  padding: 30px 20px 20px 30px;
  box-sizing: border-box;
  height: calc(100% - 80px);
  overflow-y: scroll;
  .recharge-activity {
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
    box-sizing: border-box;
  }
  .flex-row-start {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding: 25px 0;
    box-sizing: border-box;
    .activity-name {
      padding-right: 10px;
      box-sizing: border-box;
      line-height: 40px;
    }
    .bold {
      font-weight: bold;
      .color-orange {
        color: #ff7757;
      }
    }
  }
  .table-area {
    padding-top: 25px;
    box-sizing: border-box;
  }
}
/deep/ .el-table th {
  background-color: #f7f8fa;
}
</style>
